var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"Star"}},[(_vm.on)?_c('i',{staticClass:"material-icons"},[_vm._v("star")]):_c('i',{staticClass:"material-icons"},[_vm._v("star_border")])])
}
var staticRenderFns = []

export { render, staticRenderFns }